/**
 * Author: Romain Hapi Sr.
 * Version: 1.0
 * Date: 2026-06-25
 * Project: Prenim Digital
 * Copyright: Prenim UK
 */
/**
 * Appels au backend depuis le site Tchad.
 *
 * Jumeau de `services/api.js` du site UK, a une difference pres : l'adresse du
 * backend vient de `REACT_APP_TCHAD_BACKEND_URL` et non de
 * `REACT_APP_BACKEND_URL`, ce qui laisse la possibilite de router les deux
 * sites vers deux API distinctes. Aujourd'hui les deux variables pointent vers
 * le meme hote.
 *
 * Ces variables sont lues a la CONSTRUCTION, pas a l'execution : changer le
 * `.env` ne suffit pas, il faut reconstruire le bundle. Si la variable manque,
 * les appels partent vers `undefined/api` — le premier point a verifier si les
 * formulaires du Tchad restent sans reponse.
 */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_TCHAD_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const submitContact = async (data) => {
  const response = await axios.post(`${API}/contact`, {
    first_name: data.firstName,
    last_name: data.lastName,
    email: data.email,
    phone: data.phone,
    message: data.message,
  });
  return response.data;
};

export const getCareers = async () => {
  const response = await axios.get(`${API}/careers`);
  return response.data;
};

export const submitCareerApplication = async (data) => {
  const form = new FormData();
  form.append('job_id', data.jobId);
  form.append('first_name', data.firstName);
  form.append('last_name', data.lastName);
  form.append('email', data.email);
  form.append('phone', data.phone);
  form.append('cover_letter', data.coverLetter);
  if (data.cv) form.append('cv', data.cv);
  const response = await axios.post(`${API}/careers/apply`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};

